import React from "react";
import config from "lib/fr-config";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import { withStyles } from "@material-ui/core/styles";
import { getDeviceType } from "lib/deviceInfo";
import PropTypes from "prop-types";

const HEIGHT_OF_MOBILE_NAV_BAR = config.css.mobile.headerBarHeightPX;

CommonSnackbarView.propTypes = {
  open: PropTypes.bool.isRequired,
  contentComponent: PropTypes.object.isRequired,
  buttonInfoArray: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.oneOf(["primary", "secondary"]).isRequired,
      func: PropTypes.func.isRequired,
      btnText: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
        .isRequired
    })
  ).isRequired,
  zIndexOfSnackbar: PropTypes.number.isRequired
};

function CommonSnackbarView(props) {
  const { open, contentComponent, buttonInfoArray, zIndexOfSnackbar } = props;

  const CustomSnackbar = withStyles({
    anchorOriginBottomCenter: {
      zIndex: zIndexOfSnackbar,
      bottom:
        getDeviceType() === "desktop"
          ? undefined
          : `calc(env(safe-area-inset-bottom) + ${HEIGHT_OF_MOBILE_NAV_BAR}px)`
    }
  })(Snackbar);
  const CustomSnackbarContent = withStyles({
    action: {
      display: "flex",
      flexWrap: "wrap"
    },
    root: {
      /** snackbar가 중첩되는 경우 그림자가 약하면 중첩으로 보이지 않아 문제 발생 여지 있다. */
      boxShadow:
        "0px 3px 5px -1px rgba(0,0,0,0.6),0px 6px 10px 0px rgba(0,0,0,0.42),0px 1px 18px 0px rgba(0,0,0,0.36)"
    }
  })(SnackbarContent);

  const getButtonComponentArray = () => {
    const resultArray = [];
    for (let i = 0; i < buttonInfoArray.length; i++) {
      const { color, func, btnText } = buttonInfoArray[i];
      resultArray.push(
        <Button key={`btn${i}`} color={color} size={"small"} onClick={func}>
          {btnText}
        </Button>
      );
    }
    return resultArray;
  };

  return (
    <CustomSnackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      open={open}
      onClose={() => {}}
    >
      <CustomSnackbarContent
        message={contentComponent}
        action={getButtonComponentArray()}
      />
    </CustomSnackbar>
  );
}

export default CommonSnackbarView;
